import {
  AmplitudeScript,
  Environment,
  EnvironmentIdentifier,
  GoogleTagManagerScript,
  HotjarScript,
  LeanScript,
  prypcoEnv,
} from '@aw/prypco/environment';

export const environment: Environment = {
  ...prypcoEnv,
  production: true,
  testing: false,
  noIndex: false,
  dev: false,
  externalScripts: {
    amplitude: new AmplitudeScript(
      'b7eb85790636b15a5bfa1ebf201dfdf6',
      {
        defaultTracking: {
          attribution: false,
          pageViews: false,
          sessions: false,
          formInteractions: false,
          fileDownloads: false,
        },
        optOut: false,
      },
      false,
      true,
    ),
    googleTagManager: [
      new GoogleTagManagerScript('GTM-TD8BXC8S', true),
      new GoogleTagManagerScript('GTM-5NNPK4FK', true),
    ],
    hotjar: new HotjarScript(5003603, 6, true),
    lean: new LeanScript(
      'b72ca4b6-3274-4637-b9b8-e356bd99709e',
      false,
      '20e6ce3c-7982-4799-9578-091380989a17',
    ),
    gtm: true,
    intercom: false,
  },
  featureFlags: {
    blocks: {
      backOffice: true,
      devPanel: false,
      payByCard: true,
      payInstantTransfer: true,
      tapSDKId: 'pk_live_Nkbo3HlxcUSeTt94K7DpBGg5',
      portal: true,
      comingSoon: true,
    },
  },
  identifiers: {
    [EnvironmentIdentifier.MapBoxKey]:
      'pk.eyJ1IjoicHJ5cHRvIiwiYSI6ImNsZmpvbmF5bzAzMHczdHBjaHhzdHN6NHUifQ.Odt7HXtV-hIbe9jswzzw0A',
  },
  firebase: {
    apiKey: 'AIzaSyCY0q1ODpP0ClA4rBqzLluqt6qfV6PSfLo',
    authDomain: 'prypco-blocks-app.firebaseapp.com',
    projectId: 'prypco-blocks-app',
    storageBucket: 'prypco-blocks-app.firebasestorage.app',
    messagingSenderId: '227051632453',
    appId: '1:227051632453:web:3907d1f52413ccc8b3702c',
    measurementId: 'G-1DBVDYE4TJ',
  },
};
